import type { ExtrudeSegment } from "./types";

// A door or window segment widened into a bar, half the width on each side (as the agent viewer draws it).
export const extrudeSegment: ExtrudeSegment = ({ points, halfWidthPt }) => {
  if (points.length !== 2) return [];
  const [start, end] = points;
  const length = Math.hypot(end.x - start.x, end.y - start.y);
  if (length === 0) return [];

  const offsetX = (-(end.y - start.y) / length) * halfWidthPt;
  const offsetY = ((end.x - start.x) / length) * halfWidthPt;
  return [
    { x: start.x + offsetX, y: start.y + offsetY },
    { x: end.x + offsetX, y: end.y + offsetY },
    { x: end.x - offsetX, y: end.y - offsetY },
    { x: start.x - offsetX, y: start.y - offsetY },
  ];
};
